import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMathGreaterThanCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMathGreaterThanCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8.82598 7.65085L7.90085 9.42402L12.8381 12L7.90085 14.576L8.82598 16.3492L17.1619 12L8.82598 7.65085Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMathGreaterThanCircle;
